import autosize from 'autosize'
import $ from 'jquery'

$(function ($) {
  $('textarea.autosize').each(function () {
    autosize($(this))
  })
})
